module.exports = __webpack_public_path__ + "static/icons/snowing-c9654876825cf39166cd8588c1cbb341.png";